/**
 * 新增修改完成调用 modalFormOk方法 编辑弹框组件ref定义为modalForm
 * 高级查询按钮调用 superQuery方法  高级查询组件ref定义为superQueryModal
 * data中url定义 list为查询列表  delete为删除单条记录  deleteBatch为批量删除
 */
import { filterObj, getNowFormatStr } from '@/utils/util'
import { deleteAction, getAction, postAction, downFile, getFileAccessHttpUrl } from '@/api/manage'
import Vue from 'vue'
import VueDraggableResizable from 'vue-draggable-resizable'
import { ACCESS_TOKEN } from "@/store/mutation-types"
import { mixinDevice } from '@/utils/mixin.js'
import exportConfirmDate from '@/views/report/modules/exportConfirmDate'
import { getEnableSerialNumberInfo, getEnableSerialNumberList } from '@api/api'
import { mapGetters } from 'vuex'

export const JeecgListMixin = {
  mixins: [mixinDevice],
  components: {
    VueDraggableResizable,
    exportConfirmDate
  },
  ...mapGetters(["nickname", "loginName", "userInfo"]),
  data () {
    return {
      websocket:'',
      //token header
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      /*卡片样式 */
      cardStyle: '',
      /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: { },
      topQueryParam: { },
      /* 数据源 */
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 控制table高度 */
      scroll: { x: true },
      /* 排序参数 */
      isorter: {
        // column: 'createTime',
        // order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading: false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus: false,
      /* 高级查询条件生效状态 */
      superQueryFlag: false,
      /* 高级查询条件 */
      superQueryParams: '',
      /** 高级查询拼接方式 */
      superQueryMatchType: 'and',
      /** 是否加载时就执行 */
      disableMixinCreated: false,
      /* 按钮权限 */
      btnEnableList: '',
    }
  },
  created () {
    if (this.isDesktop()) {
      this.cardStyle = 'height:' + (document.documentElement.clientHeight - 100) + 'px'
    }
    if (!this.disableMixinCreated) {
      //console.log(' -- mixin created -- ')
      this.loadData()
      //初始化字典配置 在自己页面定义
      this.initDictConfig()
      //初始化按钮权限
      this.initActiveBtnStr()
    }
  },
  mounted () {
    this.initScroll()
  },
  methods: {
    delConfirm(handler,...args){
      this.$confirm('是否删除数据', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        handler(...args)
      }).catch(() => {});
    },
    invalidateConfirm(handler,...args){
      this.$confirm('是否作废数据?', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        handler(...args)
      }).catch(() => {});
    },
    timestampToTime (timestamp) {
      if (!timestamp) return
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

      let strDate = Y + M + D + h + m + s
      console.log(strDate) //2020-05-08 17:44:56
      return strDate
    },
    closeWs(){
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },
    setMa(event){
      console.log(event)
      //与已有数据比对过滤
      const qrcodeArr = event.data.split(';').filter(x => !this.checkDataSource.map(x=>x.serialNumber).includes(x))
      const params = this.getQueryParams()
      params.names = qrcodeArr
      params.rows = 999
      getEnableSerialNumberInfo(params).then((res) => {
        //再次与已有数据比对过滤
        const qrcodeArr_ = res.data.rows.filter(x => !this.checkDataSource.map(x=>x.serialNumber).includes(x))
        this.checkDataSource = this.checkDataSource.concat(qrcodeArr_)
        if(res.data.noRows.length){
          addDepotHeadAndDetailCheck({
            "supplierId": "9",
            "personid": this.userInfo().id,
            "codes": res.data.noRows.join(',')
          }).then(res=>{
            this.$message.warning(res.msg)
          })
        }
      })
    },
    loadWs(callback){
      console.log('进入loadWs==================》',process.env.VUE_APP_WS)
      this.websocket = new WebSocket(process.env.VUE_APP_WS)

      this.websocket.onopen = (event) =>{
        console.log('websocket-open=>',event)
      }

      this.websocket.onclose = ()=>{
        this.websocket = null
      }

      this.websocket.onmessage = (event)=>{
        callback(event)
      }

      this.websocket.addEventListener('close',(e)=>{
        console.log('websocket-close->',e)
      })
    },
    loadData (arg) {
      if (!this.url.list) {
        // this.$message.error("请设置url.list属性!")
        console.log('请设置url.list属性!')
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }

      var params = this.getQueryParams()//查询条件
      this.loading = true
      getAction(this.url.list, params).then((res) => {

        if (res.code === 200 && res.data && res.data.rows) {
          this.dataSource = res.data.rows
          this.ipagination.total = res.data.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        } else if (res.code === 200 && res.data && res.data.list) {
          this.dataSource = res.data.list
          this.ipagination.total = res.data.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        } else if (res.code === 200 && res.data && res.data.records) {
          this.dataSource = res.data.records
          this.ipagination.total = res.data.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        }
        // else if (res.code === 200 && res.data) {
        //   this.dataSource = res.data.records
        //   this.ipagination.total = res.data.length
        //   this.tableAddTotalRow(this.columns, this.dataSource)
        // }
        else if (res.code === 200 && res.result.records) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        }
        else if (res.code === 200 && res.result) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.pages
          this.tableAddTotalRow(this.columns, this.dataSource)
        }

        if (res.errno === 0 && res.data.list) {
          this.dataSource = res.data.list
          this.ipagination.total = res.data.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        }

        if (res.errno === 200 && res.data.list) {
          this.dataSource = res.data.list
          this.ipagination.total = res.data.total
          this.tableAddTotalRow(this.columns, this.dataSource)
        }

        if (res.code == 500) {
          this.$message.error(res.data)
        }
        if (res.code === 510) {
          this.$message.warning(res.data)
        }
        this.loading = false
        this.loadDataOk()
      })
    },
    initDictConfig () {
      //console.log("--这是一个假的方法!")
    },
    handleSuperQuery (params, matchType) {
      //高级查询方法
      if (!params) {
        this.superQueryParams = ''
        this.superQueryFlag = false
      } else {
        this.superQueryFlag = true
        this.superQueryParams = JSON.stringify(params)
        this.superQueryMatchType = matchType
      }
      this.loadData(1)
    },
    getQueryParams () {
      //获取查询条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp['superQueryParams'] = encodeURI(this.superQueryParams)
        sqp['superQueryMatchType'] = this.superQueryMatchType
      }
      let searchObj = {}
      const newUrl = [
        '/dataAcquisitionAccumulatedV2/accumulatedList',
        '/dataAcquisitionAccumulatedV2/batchNumberList',
        '/report/getByNumber',
        '/report/statisticsInStorage',
        '/codeRules/fzIdcodeBatch/list'
      ]

      Object.assign(searchObj, this.topQueryParam)

      if (this.url.list == '/serialNumber/stockList' || this.url.list == '/checkRecord/list' || this.url.list == '/codeRules/fzNodeDictionaryData/page' || this.url.list == '/codeRules/fzRuleNode/list') {
        Object.assign(searchObj, this.queryParam)
      } else if(this.url.list == '/productPi/piList' || this.url.list == '/productPi/piSecurityList') {
        searchObj.search = this.searchParam
      } else if(newUrl.find(x=>x == this.url.list) ){
        Object.assign(searchObj, this.queryParam)
      }else {
        searchObj.search = JSON.stringify(this.queryParam)
      }
      var param = Object.assign(sqp, searchObj, this.isorter, this.filters)
      // param.field = this.getQueryField()
      console.log(this.queryParam, 'this.queryParam')

      if (this.url.list == '/unit/listCertificate' || this.url.list == '/productDi/list' || this.url.list == '/productPi/list' || this.url.list == '/productPi/piList' || this.url.list == '/productPi/piSecurityList') {
        param.limit = this.ipagination.pageSize
        param.page = this.ipagination.current
      } else if(this.url.list == '/trace/medicine/info/list' || this.url.list == '/quality/transportMonitor/list' || this.url.list == '/quality/badMonitor/list' || this.url.list == '/sy/examine/licenceExamine/queryPageByCondition' || this.url.list == '/codeRules/fzIdcode/detail/list' || this.url.list == '/sy/supplier/list' || this.url.list == '/carrier/carrierManagement/list' || this.url.list == '/waybill/waybillManagement/list' || this.url.list == '/quality/afterSales/list') {
        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
      }else {
        param.currentPage = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
      }
      return filterObj(param)
    },
    getQueryField () {
      var str = "id"
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex
      })
      return str
    },

    onSelectChange (selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    onClearSelected () {
      this.selectedRowKeys = []
      this.selectionRows = []
    },
    searchQuery () {
      this.loadData(1)
    },
    superQuery () {
      this.$refs.superQueryModal.show()
    },
    searchReset () {
      if(this.queryParam.isStandard == undefined){
        this.queryParam.isStandard = '1'
      }
      this.loadData(1)
    },
    batchSetStatus: function (status) {
      if (!this.url.batchSetStatusUrl) {
        this.$message.error("请设置url.batchSetStatusUrl属性!")
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ""
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ","
        }
        var that = this
        // 
        // 
        this.$confirm('是否操作选中数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          that.loading = true
          postAction(that.url.batchSetStatusUrl, { status: status, ids: ids }).then((res) => {
            if (res.code === 200) {
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.warning(res.data.message)
            }
          }).finally(() => {
            that.loading = false
          })
        }).catch(() => {
          that.loading = false
        });

      }
    },
    batchDel: function (ruleId) {
      if (!this.url.deleteBatch) {
        this.$message.error("请设置url.deleteBatch属性!")
        return
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      } else {
        var ids = ""
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ","
        }
        var that = this
        this.$confirm('是否删除选中数据?', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            deleteAction(that.url.deleteBatch, { ids: ids,ruleId }).then((res) => {
              if (res.code === 200) {
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.data.message)
              }
            }).finally(() => {
              that.loading = false
            })
        }).catch(() => {});
      }
    },
    handleDelete: function (id, qve) {
      if ( !qve ) {
        if (!this.url.delete) {
          this.$message.error("请设置url.delete属性!")
          return
        }
        var that = this
        deleteAction(that.url.delete, { id: id }).then((res) => {
          if (res.code === 200) {
            that.loadData()
            if (res.data && res.data.message){
              that.$message.success(res.data.message)
            }else {
              that.$message.success(res.message)
            }
          } else {
            if (res.data && res.data.message){
              that.$message.warning(res.data.message)
            }else {
              that.$message.warning(res.message)
            }
          }
        })
      } else {
        if (!this.url.delete) {
          this.$message.error("请设置url.delete属性!")
          return
        }
        var that = this
        deleteAction(that.url.delete, { nodeId: id, ruleId: qve }).then((res) => {
          if (res.code === 200) {
            that.loadData()
            that.$message.success("删除成功")
          } else {
            if (res.data && res.data.message){
              that.$message.warning(res.data.message)
            }else {
              that.$message.warning(res.message)
            }
          }
        })
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = "编辑"
      this.$refs.modalForm.disableSubmit = false
    },
    handleAdd: function (obj) {
      this.$refs.modalForm.add(obj)
      this.$refs.modalForm.title = "新增"
      this.$refs.modalForm.disableSubmit = false
    },
    handleTableChange (pagination, filters, sorter) {
      console.log(pagination, 'pagination')
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      if (pagination && pagination.current) {
        this.ipagination = pagination
        console.log(this.ipagination, 'this.ipagination')
      }
      this.loadData()
    },
    handleToggleSearch () {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    // 给popup查询使用(查询区域不支持回填多个字段，限制只返回一个字段)
    getPopupField (fields) {
      return fields.split(',')[0]
    },
    modalFormOk () {
      // 新增/修改 成功时，重载列表
      this.loadData(1)
      this.getList(this.qve,this.qve2)
    },
    modalFormClose () {
      // 关闭页面时，重载列表
      this.loadData()
    },
    handleDetail: function (record, type, prefixNo) {
      this.$refs.modalDetail.show(record, type, prefixNo)
      this.$refs.modalDetail.title = type + "-详情"
    },
    /* 导出 */
    handleExportXls2 () {
      let paramsStr = encodeURI(JSON.stringify(this.getQueryParams()))
      let url = `${window._CONFIG['domianURL']}/${this.url.exportXlsUrl}?paramsStr=${paramsStr}`
      window.location.href = url
    },
    handleExportXls (params) {
      let fileName = params.name
      let isold = params.type

      let p = _.cloneDeep(this.queryParam)
      if(params.date){
        p.beginTime = params.date[0]
        p.endTime = params.date[1]
      }

      if (!fileName || typeof fileName != "string") {
        fileName = "导出文件"
      }
      let param = {}
      if(isold == 'old'){
        param.search = { ...p }
      }else{
        param = { ...p }
      }
      // if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
      //   param.search['selections'] = this.selectedRowKeys.join(",")
      // }
      param.currentPage = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      console.log("导出参数", param)
      downFile(this.url.exportXlsUrl, param).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data], { type: 'application/vnd.ms-excel' }), fileName + '.xls')
        } else {
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName + '_' + getNowFormatStr() + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link) //下载完成移除元素
          window.URL.revokeObjectURL(url) //释放掉blob对象
        }
      })
    },
    /* 导入 */
    handleImportExcel (info) {
      this.confirmLoading = true
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        if (info.file.response) {
          // this.$message.success(`${info.file.name} 文件上传成功`);
          if (info.file.response.code === 200) {
            this.$message.success(info.file.response.data || `${info.file.name} 文件上传成功`)
          } else {
            this.$message.warning(info.file.response.data, 8)
          }
          this.confirmLoading = false
          this.visible = false
          this.$emit('ok')
        } else {
          this.$message.error(`${info.file.name} ${info.file.response.data}.`)
          this.confirmLoading = false
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`文件上传失败: ${info.file.msg} `)
        this.confirmLoading = false
      }
    },
    /* 图片预览 */
    getImgView (text) {
      if (text && text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","))
      }
      return getFileAccessHttpUrl(text)
    },
    /* 文件下载 */
    uploadFile (text) {
      if (!text) {
        this.$message.warning("未知的文件")
        return
      }
      if (text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","))
      }
      let url = getFileAccessHttpUrl(text)
      window.open(url)
    },
    /* 按钮权限 */
    initActiveBtnStr () {
      let btnStrList = Vue.ls.get('winBtnStrList') //按钮功能列表 JSON字符串
      this.btnEnableList = "" //按钮列表
      let pathName = location.pathname
      if (pathName.indexOf('/plugins') > -1) {
        pathName = '/system' + pathName
      }
      if (pathName && btnStrList) {
        for (let i = 0; i < btnStrList.length; i++) {
          if (btnStrList[i].url === pathName) {
            if (btnStrList[i].btnStr) {
              this.btnEnableList = btnStrList[i].btnStr
            }
          }
        }
      }
    },
    /* 初始化表格横向或纵向滚动 */
    initScroll () {
      if (this.isMobile()) {
        this.scroll.y = ''
      } else {
        let basicLength = 274
        let searchWrapperDomLen = 0, operatorDomLen = 0
        //搜索区域
        let searchWrapperDom = document.getElementsByClassName('table-page-search-wrapper')
        //操作按钮区域
        let operatorDom = document.getElementsByClassName('table-operator')
        if (searchWrapperDom && searchWrapperDom[0]) {
          searchWrapperDomLen = searchWrapperDom[0].offsetHeight
        }
        if (operatorDom && operatorDom[0]) {
          operatorDomLen = operatorDom[0].offsetHeight + 10
        }
        this.scroll.x = 1640
        this.scroll.y = document.documentElement.clientHeight - searchWrapperDomLen - operatorDomLen - basicLength
      }
    },
    //拖拽组件
    handleDrag (column) {
      return {
        header: {
          cell: (h, props, children) => {
            const { key, ...restProps } = props
            const col = column.find((col) => {
              const k = col.dataIndex || col.key
              return k === key
            })

            if (!col || !col.width) {
              return h('th', { ...restProps }, [...children])
            }

            const dragProps = {
              key: col.dataIndex || col.key,
              class: 'table-draggable-handle',
              attrs: {
                w: 10,
                x: col.width,
                z: 1,
                axis: 'x',
                draggable: true,
                resizable: false,
              },
              on: {
                dragging: (x, y) => {
                  col.width = Math.max(x, 1)
                },
              },
            }
            const drag = h(VueDraggableResizable, { ...dragProps })
            return h('th', { ...restProps, class: 'resize-table-th' }, [...children, drag])
          },
        }
      }
    },
    /** 表格增加合计行 */
    tableAddTotalRow (columns, dataSource) {
      if (dataSource.length > 0 && this.ipagination.pageSize % 10 === 1) {
        //分页条数为11、21、31等的时候增加合计行
        let numKey = 'rowIndex'
        let totalRow = { [numKey]: '合计' }
        //需要合计的列
        let parseCols = 'initialStock,currentStock,currentStockPrice,currentWeight,initialAmount,thisMonthAmount,currentAmount,inSum,inSumPrice,' +
          'inOutSumPrice,outSum,outSumPrice,outInSumPrice,operNumber,allPrice,numSum,priceSum,prevSum,thisSum,thisAllPrice,changeAmount,' +
          'allPrice,taxMoney,currentNumber,lowSafeStock,highSafeStock,lowCritical,highCritical,preNeed,debtMoney,backMoney,allNeed,' +
          'needDebt,realNeedDebt,finishDebt,debt'
        columns.forEach(column => {
          let { key, dataIndex } = column
          if (![key, dataIndex].includes(numKey)) {
            let total = 0
            dataSource.forEach(data => {
              if (parseCols.indexOf(dataIndex) > -1) {
                if (data[dataIndex]) {
                  total += Number.parseFloat(data[dataIndex])
                } else {
                  total += 0
                }
              } else {
                total = '-'
              }
            })
            if (total !== '-') {
              total = total.toFixed(2)
            }
            totalRow[dataIndex] = total
          }
        })
        dataSource.push(totalRow)
        //总数要增加合计的行数，每页都有一行合计，所以总数要加上
        let size = Math.ceil(this.ipagination.total / (this.ipagination.pageSize - 1))
        this.ipagination.total = this.ipagination.total + size
      }
    },
    paginationChange (page, pageSize) {
      this.ipagination.current = page
      this.ipagination.pageSize = pageSize
      this.loadData(this.ipagination.current)
    },
    paginationShowSizeChange (current, size) {
      this.ipagination.current = current
      this.ipagination.pageSize = size
      this.loadData(this.ipagination.current)
    },

    // 编码规则 操作栏
    handleRuleNode(qve) {
      this.$refs.modalForm4.getList(qve.uuid)
      this.$refs.modalForm4.add(qve.uuid)
      this.$refs.modalForm4.title = "规则节点"
      this.$refs.modalForm4.disableSubmit = false
    },
    handleMakeCode(qve) {
      this.$refs.modalForm2.getMakeCode(qve.uuid, qve) // 获取生码
      this.$refs.modalForm2.add()
      this.$refs.modalForm2.title = "生码"
      this.$refs.modalForm2.disableSubmit = false
    },
    handleMakeCodeRecord(qve) {
      this.$refs.modalForm3.getList(qve)
      this.$refs.modalForm3.add(qve.uuid)
      this.$refs.modalForm3.title = "生码记录"
      this.$refs.modalForm3.disableSubmit = false
    },
    handleDictContent(qve) {
      this.$refs.modalForm2.getList(qve.uuid)
      this.$refs.modalForm2.title = "字典配置"
      this.$refs.modalForm2.disableSubmit = false
    },
    handleMakeCodeList(qve, qve2) {
      let uuid = qve.uuid
      let ruleId = qve2

      this.$refs.modalForm.getList(uuid, ruleId)
      this.$refs.modalForm.title = "生码列表"
      this.$refs.modalForm.disableSubmit = false
    }


  }

}